import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { styled } from "@mui/material";
import { ACTION_STATUS } from "constants/actions";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../../Typography/Title";
import useAvailableQuantityUnits from "../../utils/useAvailableOperationUnits";
import DateSpan from "../date-span/DateSpan";
import DetailSection from "../DetailSection";
import WateringLimits from "./WateringLimits";
import QuantityInput from "../../../action-inputs/quantity/QuantityInput";
import ActionModalDescriptionSection from "../description/ActionModalDescriptionSection";

const WateringQuantityRow = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  flexWrap: "wrap",
});

const WateringLimitsSlot = styled("div")({
  flex: "1 1 240px",
  minWidth: "220px",
  maxWidth: "300px",
});

const WateringSuggestion = ({
  viewMode,
  isFullWidth,
  isProposedValue,
  operationTypeId,
  isNewVersion,
}) => {
  const { t } = useTranslation();
  const status = ACTION_STATUS.suggested;
  const { values } = useFormikContext();
  const { availableQuantityUnits } = useAvailableQuantityUnits(
    values.taskId,
    operationTypeId,
  );
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  return (
    <div className="action-modal-card action-details-box ">
      <div className={isFullWidth && "details-half-width"}>
        <Title title={t("ActionModal.Details.Suggested")} />
        {!isNewVersion && <DateSpan viewMode={viewMode} status={status} />}
        <DetailSection
          title={t("ActionModal.WaterQuantity")}
          isRequired={!isViewMode}
          isNewVersion={isNewVersion}
        >
          <WateringQuantityRow>
            <QuantityInput
              isViewMode={isViewMode}
              isProposed={isProposedValue}
              task="watering"
              quantityOptions={availableQuantityUnits}
            />
            <WateringLimitsSlot>
              <WateringLimits />
            </WateringLimitsSlot>
          </WateringQuantityRow>
        </DetailSection>
        <ActionModalDescriptionSection
          task="watering"
          isViewMode={isViewMode}
          isProposed={isProposedValue}
          isNewVersion={isNewVersion}
        />
      </div>
    </div>
  );
};

export default WateringSuggestion;
